import React from 'react';
import Slider from 'react-slick';

import { Settings } from 'src/types/Carousel';
import { Image } from '../../atoms/Image';
import * as styles from './UspBanner.styles';

const { SlickStyles } = styles;

interface Slide {
  title: string;
  subtitle: string;
  image: string;
  alt: string;
}

interface UspBannerProps {
  slides: Slide[];
}

const sliderSettings: Settings = {
  dots: false,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
      },
    },
  ],
};

const testName = 'UspBanner';

export const UspBanner = ({ slides }: UspBannerProps) => {
  const renderSlides = () => {
    if (slides.length === 0) {
      return null;
    }

    return slides.map(
      (slide: Slide): JSX.Element => (
        <div css={styles.SlideWrapper} key={slide.title}>
          <div css={styles.Slide}>
            <div css={styles.IconWrapper}>
              <Image src={slide.image} alt={slide.alt} />
            </div>
            <div css={styles.TextBlock}>
              <p css={styles.Title}>{slide.title}</p>
              <p css={styles.Copy}>{slide.subtitle}</p>
            </div>
          </div>
        </div>
      ),
    );
  };

  return (
    <>
      <SlickStyles />
      <div css={styles.Wrapper}>
        <div
          css={styles.ResponsiveView}
          data-testid={`${testName}-ResponsiveViewDesktop`}
          data-device="desktop"
        >
          {renderSlides()}
        </div>
        <div
          css={styles.ResponsiveView}
          data-testid={`${testName}-ResponsiveViewMobile`}
          data-device="mobile"
        >
          <Slider {...sliderSettings}>{renderSlides()}</Slider>
        </div>
      </div>
    </>
  );
};
